'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface ActivityTimelineProps {
  userId: string;
  groupBy?: 'hour' | 'day' | 'week';
  showDetails?: boolean;
}

export function ActivityTimeline({ userId, groupBy, showDetails }: ActivityTimelineProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Activity Timeline</Title>
      <Text c="dimmed" size="sm">Activity timeline coming soon</Text>
    </Paper>
  );
}